// 会员管理
export default [
  {
    path: "/member",
    meta: { title: "会员管理", isMenu: true },
    component: () => import("../views/marketing/index.vue"),
    children: [
      {
        path: "/member/memberList",
        // name: "memberList",
        meta: { title: "会员列表", isMenu: true },
        component: () => import("../views/member/memberList.vue"),
      },
      {
        path: "/member/detail/memberDetail",
        // name: "memberDetail",
        meta: { title: "已购项目" },
        component: () => import("../views/member/detail/memberDetail.vue"),
      },
    ],
  },
]
